import React from 'react'
import { FaPaperclip } from 'react-icons/fa'

// Components
import { StyledVerificationNote } from './VerificationNote.styles'

// CONSTANTS
import { tenantColors } from '../../../_constants/colors'

// Helpers
import { FilesManager } from '../../FilesManager'
import { VerificationNoteProps } from './VerificationNote.proptypes'
import { formatValueByType } from '../../../_helpers'

// Hooks
import { useModal } from '../../../_reduxHooks/modal.hook'
import { useTenant } from '../../../_reduxHooks/tenant.hook'

const VerificationNote = ({ verification, showDocs }) => {
  const { openModal } = useModal()
  const { tenant } = useTenant()
  let { contact, documents, note, sentiment, verification_type_name } = verification

  return (
    <StyledVerificationNote
      activeTenantColors={tenantColors[tenant]}
      className={`note`}
      onClick={(e) => {
        if (!showDocs) {
          openModal(VerificationNote, { tenant, verification, showDocs: true })
        }
      }}
      showDocs={showDocs}
    >
      <div className="content">
        {note.created_by ? (
          <div className="created-by-label">{`${note.created_by.first_name} ${note.created_by.last_name}`}</div>
        ) : null}
        {contact && (
          <p className="contact-label">{`Contact: ${contact.first_name} ${
            contact.last_name ? contact.last_name : ''
          }`}</p>
        )}
      </div>
      <div className="content">
        <div className={`indicator ${sentiment}`} />
        <div className={'verification_name'}>{verification_type_name}</div>
        <span>{formatValueByType(note.created_at, 'dateTime', { date: 'M.DD.YY', time: 'h:mm:ss A' })}</span>
      </div>
      <div className="content">
        <p className={`message`}>{note.body}</p>
        {documents.length ? (
          <span>
            <div className={'doc-count'} title={`${documents.length} Files Attached`}>
              {documents.length}
              <FaPaperclip />
            </div>
          </span>
        ) : null}
      </div>
      {showDocs && documents.length ? <FilesManager allowDelete={false} allowUpload={false} files={documents} /> : null}
    </StyledVerificationNote>
  )
}

export { VerificationNote }

VerificationNote.propTypes = VerificationNoteProps

VerificationNote.defaultProps = {
  showDocs: false,
}
